"use strict";
/* tslint:disable:no-object-literal-type-assertion */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONFIGURATION_KEYS = void 0;
const _1 = require(".");
const baseName = "highlights";
exports.CONFIGURATION_KEYS = {
    tasks: {
        thresholds: {
            descriptionChanges: {
                name: `${baseName}.tasks.thresholds.descriptionChanges`,
                chain: [_1.ConfigurationEntityType.Team],
                type: {}
            },
            commentCount: {
                name: `${baseName}.tasks.thresholds.commentCount`,
                chain: [_1.ConfigurationEntityType.Team],
                type: {}
            },
            needAttention: {
                name: `${baseName}.tasks.thresholds.needAttention`,
                chain: [_1.ConfigurationEntityType.Team],
                type: {}
            },
        },
        weights: {
            priority: {
                name: `${baseName}.tasks.weights.priority`,
                chain: [_1.ConfigurationEntityType.Team],
                type: {}
            },
            type: {
                name: `${baseName}.tasks.weights.type`,
                chain: [_1.ConfigurationEntityType.Team],
                type: {}
            },
            insight: {
                name: `${baseName}.tasks.weights.insight`,
                chain: [_1.ConfigurationEntityType.Team, _1.ConfigurationEntityType.InsightRule],
                type: {}
            },
            insightDecayFactor: {
                name: `${baseName}.tasks.weights.insightDecayFactor`,
                chain: [_1.ConfigurationEntityType.Team, _1.ConfigurationEntityType.InsightRule],
                type: {}
            },
            commentCount: {
                name: `${baseName}.tasks.weights.commentCount`,
                chain: [_1.ConfigurationEntityType.Team],
                type: {}
            },
            descriptionChangeCount: {
                name: `${baseName}.tasks.weights.descriptionChangeCount`,
                chain: [_1.ConfigurationEntityType.Team],
                type: {}
            },
            descriptionChangeDuringInProgress: {
                name: `${baseName}.tasks.weights.descriptionChangeDuringInProgress`,
                chain: [_1.ConfigurationEntityType.Team],
                type: {}
            },
            assigneeChangeLast24Hours: {
                name: `${baseName}.tasks.weights.assigneeChangeLast24Hours`,
                chain: [_1.ConfigurationEntityType.Team],
                type: {}
            },
            priorityIncreaseLast24Hours: {
                name: `${baseName}.tasks.weights.priorityIncreaseLast24Hours`,
                chain: [_1.ConfigurationEntityType.Team],
                type: {}
            },
            statusIsBlocked: {
                name: `${baseName}.tasks.weights.statusIsBlocked`,
                chain: [_1.ConfigurationEntityType.Team],
                type: {}
            },
            flagged: {
                name: `${baseName}.tasks.weights.flagged`,
                chain: [_1.ConfigurationEntityType.Team],
                type: {}
            }
        }
    },
    prs: {
        thresholds: {
            needAttention: {
                name: `${baseName}.prs.thresholds.needAttention`,
                chain: [_1.ConfigurationEntityType.Team],
                type: {}
            },
        },
        weights: {
            insight: {
                name: `${baseName}.prs.weights.insight`,
                chain: [_1.ConfigurationEntityType.Team, _1.ConfigurationEntityType.InsightRule],
                type: {}
            },
            insightDecayFactor: {
                name: `${baseName}.prs.weights.insightDecayFactor`,
                chain: [_1.ConfigurationEntityType.Team, _1.ConfigurationEntityType.InsightRule],
                type: {}
            },
        }
    }
};
//# sourceMappingURL=highlights.js.map